// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6SR-F","col":"styles_col__1emby"};